import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { usePermissionDelete } from "src/api/client-api/permissions/useDeletePermission";
import { getAllPermissionsKey, Permission } from "src/api/client-api/permissions/useGetAllPermissions";
import { MenuItemType } from "src/components/ActionsPopover/ActionsPopover.types";
import { useFoodpilotContext } from "src/context/FoodpilotContext";

export const usePermissionsMenuItems = (onEditPermission: (permission: Permission) => void) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const deletePermission = usePermissionDelete();
    const { isAdmin } = useFoodpilotContext();

    if (!isAdmin()) return [];

    const menuItemsAcc: MenuItemType<Permission>[] = [];

    menuItemsAcc.push({
        icon: <Edit />,
        label: t("modifier"),
        onClick: (entity) => {
            onEditPermission(entity);
        },
    });

    menuItemsAcc.push({
        icon: <Delete />,
        label: t("supprimer"),
        onClick: (entity) => {
            deletePermission.mutate(entity.id, {
                onSuccess: () => {
                    queryClient.invalidateQueries([getAllPermissionsKey]);
                },
            });
        },
    });

    return menuItemsAcc;
};
